import { createAsyncThunk } from '@reduxjs/toolkit';
import { ACCOUNT_FEATURE, selectAccountId, selectApi, selectUserId } from '@socialive/common';
import { selectFeature } from '@socialive/features';
import getIdFromSelfLink from '~/helpers/getIdFromSelfLink';
import { setAccountChannels } from '../slice';

export default createAsyncThunk('accountInfo/getAccountChannels', async ({ trigger }, { dispatch, getState }) => {
  const api = selectApi(getState());
  const accountId = selectAccountId(getState());
  const userId = selectUserId(getState());
  const [, { enabled: spacesEnabled }] = selectFeature(ACCOUNT_FEATURE.SPACES)(getState());

  const url = spacesEnabled
    ? `/v1/accounts/${accountId}/spaces?userId=${userId}`
    : `/remoteStreams/search/findByAccountId?accountID=${accountId}&projection=list&size=250&sort=createdAt,desc`;

  const response = await api(url);

  let channels;
  if (spacesEnabled) {
    channels = response.map(({ user, ...space }) => ({
      ...space,
      creatorName: user.name,
    }));
  } else {
    const { remoteStreams } = response;
    channels = remoteStreams.map(({ userName, ...channel }) => ({
      ...channel,
      id: +getIdFromSelfLink(channel),
      creatorName: userName,
    }));
  }

  await dispatch(setAccountChannels({ channels, trigger }));

  return channels;
});
